import styled from 'styled-components';
import { Tabs } from 'antd';

export const CustomTabsPanel = styled(Tabs)`
  .ant-tabs-nav .ant-tabs-tab-active {
    color: #524e4f;
  }
`;
